module.exports = __webpack_public_path__ + "img/Marquage.0a6c4da.jpg";